import { createElement, forwardRef, memo, MutableRefObject, RefObject } from "react";
import classNames from "classnames";
import { OverlayScrollbarsComponent, OverlayScrollbarsComponentProps } from "overlayscrollbars-react";

import "overlayscrollbars/css/OverlayScrollbars.css";
import styles from "./styles.module.scss";

export type ScrollbarPropsType = Omit<OverlayScrollbarsComponentProps, "ref"> & {
  ref?: ((instance: OverlayScrollbarsComponent) => void) | RefObject<OverlayScrollbarsComponent> | MutableRefObject<OverlayScrollbarsComponent | undefined> | null
};

export type ScrollbarType = OverlayScrollbarsComponent;

export const Scrollbars = memo<ScrollbarPropsType>(forwardRef<any, ScrollbarPropsType>((({ className, ...props }, ref) => {
  return createElement(OverlayScrollbarsComponent, {
    ref,
    ...props,
    options: {
      ...props?.options,
      scrollbars: {
        autoHide: "leave",
        ...props?.options?.scrollbars,
      },
    },
    className: classNames(styles.root, props.options?.className, className, "os-theme-dark"),
  });
})));